// removed by extract-text-webpack-plugin
module.exports = {"Header":"_3UVRa6DQp-CbK9ic0t8_HF","AlertIcon":"_3SPFC_3mYDk7ljsuWTuRiK"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/LoginForm/index.css
// module id = 810
// module chunks = 0